import React, { useState } from "react";
import { Assignee } from "shared/datamodel/schemas/task";

export const TagsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M4.17658 4.88245C4.56642 4.88245 4.88245 4.56642 4.88245 4.17658C4.88245 3.78673 4.56642 3.4707 4.17658 3.4707C3.78673 3.4707 3.4707 3.78673 3.4707 4.17658C3.4707 4.56642 3.78673 4.88245 4.17658 4.88245Z"
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 3.11762V5.84159C1 6.22064 1.15035 6.58416 1.41858 6.8524L7.14745 12.5813C7.28018 12.714 7.43777 12.8193 7.61121 12.8912C7.78464 12.963 7.97053 13 8.15826 13C8.34599 13 8.53188 12.963 8.70532 12.8912C8.87875 12.8193 9.03634 12.714 9.16907 12.5813L12.5813 9.16907C12.714 9.03634 12.8193 8.87875 12.8912 8.70532C12.963 8.53188 13 8.34599 13 8.15826C13 7.97053 12.963 7.78464 12.8912 7.61121C12.8193 7.43777 12.714 7.28018 12.5813 7.14745L6.85169 1.41858C6.58377 1.1507 6.22045 1.00015 5.84159 1H3.11762C2.55599 1 2.01737 1.22311 1.62024 1.62024C1.22311 2.01737 1 2.55599 1 3.11762V3.11762Z"
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EditTagsIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 10.3841C1 10.7462 1.29356 11.0397 1.65569 11.0397H3.33717C3.51152 11.0397 3.6787 10.9703 3.80173 10.8468L10.4596 4.1625C10.8056 3.81508 11 3.34388 11 2.85255C11 2.36122 10.8056 1.89002 10.4596 1.5426C10.1135 1.19518 9.64417 1 9.15478 1C8.6654 1 8.19606 1.19518 7.85002 1.5426L1.19113 8.22795C1.06873 8.35084 1 8.51723 1 8.69067V10.3841Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path d="M7.19739 2.19897L9.80692 4.81888" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
};

export const AddTagIcon = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.20044 6.29179L11.38168 6.29162" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M6.29106 1.2L6.29089 11.38124" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};

export const TagVisibleIcon = () => {
  return (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 5.50024C6.25 5.89807 6.40804 6.2796 6.68934 6.5609C6.97064 6.84221 7.35218 7.00024 7.75 7.00024C8.14782 7.00024 8.52936 6.84221 8.81066 6.5609C9.09196 6.2796 9.25 5.89807 9.25 5.50024C9.25 5.10242 9.09196 4.72089 8.81066 4.43958C8.52936 4.15828 8.14782 4.00024 7.75 4.00024C7.35218 4.00024 6.97064 4.15828 6.68934 4.43958C6.40804 4.72089 6.25 5.10242 6.25 5.50024Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 5.5C12.7 8.5 10.45 10 7.75 10C5.05 10 2.8 8.5 1 5.5C2.8 2.5 5.05 1 7.75 1C10.45 1 12.7 2.5 14.5 5.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TagHiddenIcon = () => {
  return (
    <svg width="14" height="7" viewBox="0 -1 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="5.54672" y1="4.10994" x2="5.28024" y2="5.59609" stroke="currentColor" strokeLinecap="round" />
      <line
        x1="0.5"
        y1="-0.5"
        x2="2.00985"
        y2="-0.5"
        transform="matrix(0.176497 0.984301 0.984301 -0.176497 8.82605 3.46875)"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <line x1="2.64353" y1="2.95989" x2="1.86323" y2="4.25248" stroke="currentColor" strokeLinecap="round" />
      <line
        x1="0.5"
        y1="-0.5"
        x2="2.00985"
        y2="-0.5"
        transform="matrix(0.516804 0.856104 0.856104 -0.516804 11.6646 2.12964)"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M1 0.912109C2.0957 2.71604 4.3709 3.95576 7 3.95576C9.6291 3.95576 11.9043 2.71604 13 0.912109"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DueDateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
      <path
        d="M7.01764 13.3163H2.36842C2.00549 13.3163 1.65743 13.1721 1.4008 12.9155C1.14417 12.6588 1 12.3108 1 11.9479V3.73732C1 3.37439 1.14417 3.02633 1.4008 2.7697C1.65743 2.51307 2.00549 2.3689 2.36842 2.3689H10.579C10.9419 2.3689 11.29 2.51307 11.5466 2.7697C11.8032 3.02633 11.9474 3.37439 11.9474 3.73732V6.47416"
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2632 14.0005C12.7747 14.0005 14.0001 12.7752 14.0001 11.2637C14.0001 9.75218 12.7747 8.52686 11.2632 8.52686C9.75169 8.52686 8.52637 9.75218 8.52637 11.2637C8.52637 12.7752 9.75169 14.0005 11.2632 14.0005Z"
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9.21045 1.00049V3.73733" stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3.73682 1.00049V3.73733" stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 6.47412H11.9474" stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M11.2632 10.2346V11.2637L11.9474 11.9479"
        stroke="#1E1E1E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function AssigneeIcon({ assignee }: { assignee: Assignee | null }) {
  const [imageError, setImageError] = useState(false);

  if (!assignee || imageError) {
    return (
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.5" cy="7.5" r="7" fill="white" stroke="#1E1E1E" />
        <path
          d="M4.85303 6.1766C4.85303 6.87864 5.13191 7.55193 5.62833 8.04835C6.12475 8.54477 6.79804 8.82366 7.50009 8.82366C8.20213 8.82366 8.87542 8.54477 9.37184 8.04835C9.86826 7.55193 10.1471 6.87864 10.1471 6.1766C10.1471 5.47456 9.86826 4.80127 9.37184 4.30485C8.87542 3.80843 8.20213 3.52954 7.50009 3.52954C6.79804 3.52954 6.12475 3.80843 5.62833 4.30485C5.13191 4.80127 4.85303 5.47456 4.85303 6.1766Z"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5293 13.3236C3.5293 12.6215 3.80818 11.9482 4.3046 11.4518C4.80102 10.9554 5.47431 10.6765 6.17636 10.6765H8.82341C9.52546 10.6765 10.1987 10.9554 10.6952 11.4518C11.1916 11.9482 11.4705 12.6215 11.4705 13.3236"
          stroke="#1E1E1E"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <img
      src={assignee.thumbnail}
      alt={assignee.name}
      onError={() => setImageError(true)}
      style={{ width: 17, height: 17, borderRadius: "50%", objectFit: "cover" }}
    />
  );
}
